import { Invoice, InvoiceSearchForm, OrganizationInvoice } from 'entities/invoice'
import { ProductSet } from 'entities/product_set'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { ApiSet, BaseResponse, useShowApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from 'utils/network/axios'

export type InvoiceResponse = BaseResponse & {
    invoices: Invoice[]
    organizationInvoices?: OrganizationInvoice[]
    productSets?: ProductSet[]
}

export type InvoiceApiSet = ApiSet<InvoiceResponse> & { execute: () => void }

export function useInvoiceApi(searchForm?: Form<InvoiceSearchForm>): InvoiceApiSet {
    const api = useShowApi<InvoiceResponse>(new CraifHttpClient(), {
        initialResponse: { invoices: [] },
    })

    const execute = (): void => {
        const apiPath = `invoices/`
        api.execute(apiPath, searchForm?.object)
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm?.object])

    return { ...api, execute: execute }
}
